import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Modal, TextFieldInput, Error } from '@cyberint/dsc';
import { useClickOutside } from '@cyberint/stateful';
import { t } from '../../../i18n';
import { useContactAdmin } from './useContactAdmin';
import UserDetails from './UserDetails';
import { ContactMyAdminWrapper } from './styled';

export const SIZE = { width: '500px', height: '300px' };

export const UserInfoBase = ({ user, signOut, environmentCustomerId, features }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentClickedTime, setCurrentClickedTime] = useState(Date.now());
  const dropdownRef = useRef(null);
  const { sendMessage, openModal, closeModal, isOpenContactAdmin, message, setMessage, isLoading } = useContactAdmin();
  const TIME_VALID_FOR_RECLICK = 200;

  const setOpenState = event => {
    event.stopPropagation();
    const currentTime = Date.now();

    // Because we have outside click on a place and click in area which in outside the click but inside the DOM
    // its causes outside click first and inside click right after which cause its close and reopen.
    // the time i used here is a time which be normal for not auto outside click and inside click. and behave normally
    if (currentTime - currentClickedTime > TIME_VALID_FOR_RECLICK) {
      setIsOpen(true);
    }
  };

  const setOutsideClick = event => {
    event.stopPropagation();
    setIsOpen(false);
    setCurrentClickedTime(Date.now());
  };

  useClickOutside(dropdownRef, setOutsideClick, isOpen);

  const clickItem = e => {
    e.stopPropagation();
    setIsOpen(false);
  };

  const onChange = e => setMessage(e.target.value);
  const onKeyDown = e => e.code === 'Enter' && e.stopPropagation();

  const invalid = typeof message === 'string' && (message.trim().length === 0 || message.length > 255);

  return (
    <div data-testid="button-user-setting-icon-topbar" className="userSettings" onClick={e => setOpenState(e)}>
      <div className="user-first-char">{user && user.fullname && user.fullname.charAt(0)}</div>
      {isOpen && (
        <div ref={dropdownRef}>
          <UserDetails
            user={user}
            signOut={signOut}
            onClick={clickItem}
            onClickContactAdmin={openModal}
            environmentCustomerId={environmentCustomerId}
            features={features}
          />
        </div>
      )}
      {/* putting this here and not inside UserDetails to keep it outside the click-outside boundary */}
      {isOpenContactAdmin && (
        <Modal
          size={SIZE}
          isOpen={isOpenContactAdmin}
          isLoading={isLoading}
          title={t('topbar.contactMyAdmin')}
          content={
            <ContactMyAdminWrapper>
              <TextFieldInput isMultiline rows={5} onChange={onChange} onKeyDown={onKeyDown} value={message} />
              {!!invalid && <Error>{t('topbar.contactMyAdminValidation')}</Error>}
            </ContactMyAdminWrapper>
          }
          disabled={isLoading || invalid || !message}
          okText={t('topbar.contactMySend')}
          onOk={sendMessage}
          onClose={closeModal}
        />
      )}
    </div>
  );
};

UserInfoBase.propTypes = {
  user: PropTypes.object.isRequired,
  signOut: PropTypes.func.isRequired,
  environmentCustomerId: PropTypes.string,
  features: PropTypes.arrayOf(PropTypes.string)
};
